import { Time } from '../types';

export const getInputValue = (value: Time) => {
  if (value && 'minute' in value && 'hour' in value) {
    const { minute, hour } = value;
    const minutes = minute < 10 ? `0${minute}` : minute.toString();
    const hours = hour < 10 ? `0${hour}` : hour.toString();
    return `${hours}:${minutes}`;
  }
  return '';
};
